import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "size-full max-w-[1200px] mx-auto flex flex-col" };
const _hoisted_2 = { class: "header-bar flex-none w-full bg-black flex justify-between items-center py-3" };
const _hoisted_3 = { class: "gap-4 w-auto hidden lg:flex" };
const _hoisted_4 = { class: "flex-1 w-full bg-white overflow-y-scroll no-scrollbar scroll-smooth" };
import { Menu, Plus } from 'lucide-vue-next';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-view',
    setup(__props) {
        const w = computed(() => {
            return window.serverData || {
                brands: [],
                categories: [],
                userId: 0
            };
        });
        const navListing = () => {
            if (w.value.userId === 0) {
                window.location.href = '/login?next=create-listing';
            }
            else {
                window.location.href = '/create-listing';
            }
        };
        const navLogin = () => {
            window.location.href = '/login';
        };
        const navProfile = () => {
            window.location.href = '/profile-settings';
        };
        return (_ctx, _cache) => {
            const _component_market_tab = _resolveComponent("market-tab");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Menu), { class: "block lg:hidden size-8 text-white" }),
                    _cache[6] || (_cache[6] = _createElementVNode("a", { href: "/" }, [
                        _createElementVNode("img", {
                            src: "/images/logo.png",
                            alt: "Logo",
                            class: "h-8"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (navListing())),
                            class: "cursor-pointer w-auto h-[40px] flex-none flex items-center pl-1 pr-2.5 bg-white border border-white text-black rounded-[5px]"
                        }, [
                            _createVNode(_unref(Plus), { class: "size-8 p-1" }),
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-medium" }, "Sell Watch", -1))
                        ]),
                        (w.value.userId === 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: _cache[1] || (_cache[1] = ($event) => (navLogin())),
                                class: "cursor-pointer w-auto h-[40px] flex-none flex items-center px-3 bg-black text-white rounded-[5px]"
                            }, [...(_cache[4] || (_cache[4] = [
                                    _createElementVNode("span", { class: "font-medium text-xl" }, "LOGIN", -1)
                                ]))]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: _cache[2] || (_cache[2] = ($event) => (navProfile())),
                                class: "cursor-pointer w-auto h-[40px] flex-none flex items-center pl-1 pr-2.5 bg-black border border-white text-white rounded-[5px]"
                            }, [
                                _createVNode(_unref(Menu), { class: "size-8 p-1" }),
                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-medium" }, "Menu", -1))
                            ]))
                    ]),
                    _createVNode(_unref(Menu), { class: "opacity-0 block lg:hidden size-8 text-white" })
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_market_tab)
                ]),
                _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"flex-none w-full bg-black mt-3\" data-v-091f97d0><div class=\"grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3\" data-v-091f97d0><div class=\"px-4 mb-4\" data-v-091f97d0><div class=\"text-2xl mb-3\" data-v-091f97d0>Personalized Support</div><ul data-v-091f97d0><li data-v-091f97d0><a class=\"text-base\" href=\"https://wa.me/601110404004\" target=\"_blank\" data-v-091f97d0>Hotline: +60111 0404 004</a></li></ul></div><div class=\"px-4 mb-4\" data-v-091f97d0><div class=\"text-2xl mb-3\" data-v-091f97d0>About Billson Watch</div><ul data-v-091f97d0><li class=\"text-base font-light py-1\" data-v-091f97d0><a href=\"faq\" data-v-091f97d0>How this website works?</a></li><li class=\"text-base font-light py-1\" data-v-091f97d0><a href=\"signup\" data-v-091f97d0>Create a seller accout</a></li><li class=\"text-base font-light py-1\" data-v-091f97d0><a href=\"faq\" data-v-091f97d0>Frequently asked questions</a></li></ul></div><div class=\"px-4 mb-4\" data-v-091f97d0><div class=\"text-2xl mb-3\" data-v-091f97d0>Terms</div><ul data-v-091f97d0><li class=\"text-base font-light py-1\" data-v-091f97d0><a href=\"privacy-policy\" data-v-091f97d0>Privacy Policy</a></li><li class=\"text-base font-light py-1\" data-v-091f97d0><a href=\"terms-service\" data-v-091f97d0>Terms of Service</a></li></ul></div></div></div><div class=\"w-full h-16 bg-red-500 flex-none\" data-v-091f97d0></div>", 2))
            ]));
        };
    }
});
